import Axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Button, Modal, OverlayTrigger, Popover } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import AxiosConfig from 'src/utilities/AxiosConfig';
import { shouldAllowAccess } from 'src/utilities/helper';
import { AttachmentRecordType, BillingGroupType, InvoiceType } from '../types';
import { createMessage, createSignature, createSubject } from './createHTMLFromDb';
import './InvoiceEmailPreview.css';
import IconBuilder from 'src/utilities/iconBuilder/IconBuilder';
import snackBar from 'src/utilities/snackBar/SnackBar';

interface IProps {
    setShowEmailPreview: (showEmailPreview: boolean) => void;
    currentBillingGroup: BillingGroupType;
    setCurrentBillingGroup: Function;
    currentInvoice: InvoiceType;
    billingGroups: BillingGroupType[];
    setShowEditBillingGroup: Function;
    extension: string;
    getInvoicesByIGorPC: Function
    invoiceIndex: number
    saveInvoice:(entryToSave: InvoiceType, entriesIndex: number) => void
    employeeID: number
}
interface EmailProperties{
    bodyContent: string
    to: string
    cc: string
    bcc: string
    isHtml: boolean
    InvoiceStoreLocation: string
    InvoiceNumber: string
    subject: string
    isPDF:boolean
    isXLSX: boolean
}
interface EmailValidationSchema{
    to: boolean
    cc: boolean
    bcc: boolean
    subject: boolean
}
interface fileObject{
    url: string
    extension:string
}
const InvoiceEmailPreview = (props: IProps) => {
    //r-18-lint-cm
    //eslint-disable-next-line
    const { setShowEmailPreview, currentBillingGroup, setCurrentBillingGroup, currentInvoice, billingGroups, setShowEditBillingGroup, extension, employeeID} = props;
    const [loaded, setLoaded] = useState(false);
    const [showSpecialInstructions, setShowSpecialInstructions] = useState(false);
    const [showUploader, setShowUploader] = useState(false)
    const [attachmentName, setAttachmentName] = useState<string | null>(null)
    //r-18-lint-cm
    //eslint-disable-next-line
    const [relativePathString, setRelativePathString] = useState("");
    const [files, setFiles] = useState([] as fileObject[])
    const config = AxiosConfig.configValue("min");
    const bGroup = billingGroups.find((group: BillingGroupType) => group.BillingGroupID === currentInvoice.BillingGroupID);
    // let attachID = 0;
    const [emailValidation, setEmailValidation] = useState<EmailValidationSchema>({
        to: true,
        cc: true,
        bcc: true,
        subject: true
    })
    const [loadingFile, setLoadingFile] = useState(true)
    const storageLocation = process.env.REACT_APP_INVOICE_PROGRESS_FILES_STORAGE_LOCATION;
    const containerName = process.env.REACT_APP_INVOICE_PROGRESS_FILES_CONTAINER_NAME;
    const fileStoreLocationId = process.env.REACT_APP_INVOICE_PROGRESS_FILES_FILE_STORE_LOCATION_ID;

    let filenamesTemp: string = ``;

    const  makeSubjectForInvoiceEmail = (subject: string) => {
        let newSubject = subject.replace("[INVOICE#]", currentInvoice.InvoiceNumber)
                        .replace("[WEEKENDING]", moment(currentInvoice.WeekEnding).format('MM/DD/YYYY'))
        // //console.log("New Subject", newSubject)
        return newSubject
    }

    const [emailProperties, setEmailProperties] = useState<EmailProperties>({
        bodyContent : (currentBillingGroup?.EmailMessage ?? "") + (currentBillingGroup?.EmailSignature ?? ""),
        to: currentBillingGroup?.EmailTo ?? "",
        cc: currentBillingGroup?.EmailCC ?? "",
        bcc: currentBillingGroup?.EmailBCC ?? "",
        isHtml: true,
        subject: makeSubjectForInvoiceEmail(currentBillingGroup.EmailSubject ?? ""),
        isPDF: currentBillingGroup?.isPDF ?? false,
        isXLSX: currentBillingGroup?.isXLSX ?? false,
        InvoiceStoreLocation: currentBillingGroup?.InvoiceStorageLocation ?? "",
        InvoiceNumber: currentInvoice?.InvoiceNumber ?? ""
    })

    const updateEmailProperties = (key: keyof EmailProperties, edit: string) => {
        var copyEmail: EmailProperties = emailProperties
        if(typeof copyEmail[key] === "boolean"){
            copyEmail = {...copyEmail, [key] : !copyEmail[key]}
        }
        else{
            copyEmail = {...copyEmail, [key] : edit}
        }
        setEmailValidation({...ValidateEmailProperties(copyEmail)})
        setEmailProperties({...copyEmail})
    }
    const ValidateEmailProperties = (email: EmailProperties) => {
        let emailRe = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
        var emailValidation: EmailValidationSchema = {
            to: true,
            cc: true,
            bcc: true,
            subject: true
        }
        if(email.to == null || email.to == ""){
            emailValidation.to = false
        }
        var listTo = email.to.split(";")
        for(var i = 0; i< listTo.length && emailValidation.to == true; i++){
            var x = listTo[i].trim()
            if(x === ""){
                continue
            }
            if(!emailRe.test(x)){
                emailValidation.to = false
                break
            }
        }

        var listCC = email.cc.split(";")
        for(var i = 0; i< listCC.length; i++){
            var x = listCC[i].trim()
            if(x === ""){
                continue
            }
            if(!emailRe.test(x)){
                emailValidation.cc = false
                break
            }
        }

        var listBCC = email.bcc.split(";")
        for(var i = 0; i< listBCC.length; i++){
            var x = listBCC[i].trim()
            if(x === ""){
                continue
            }
            if(!emailRe.test(x)){
                emailValidation.bcc = false
                break
            }
        }
        if(email.subject == null || email.subject == ""){
            emailValidation.subject = false
        }
        return emailValidation
    }
    const DisplayEmailError = (props: {message: string}) => {
        return(
            <OverlayTrigger 
            placement='left'
            overlay={(
                <Popover id='edit-billing-group-email-info'>
                    <Popover.Content>
                        <span>{props.message}</span>
                    </Popover.Content>
                </Popover>
            )}
        >
            <span className='material-icons' style={{lineHeight: 2, color: "red"}}>warning</span>
        </OverlayTrigger>
        )
    }
    //console.log(attachmentRecords)
    useEffect(() => {
        setCurrentBillingGroup(bGroup);
        setLoaded(true);
        if (currentBillingGroup.SpecialInstructions !== null && currentBillingGroup.SpecialInstructions !== "") {
            setShowSpecialInstructions(true);
        }
        if (currentInvoice.AttachmentId !== 0) {
            handlesetAttachmentName(`${currentInvoice.InvoiceNumber}.xlsx`)
        }
        //r-18-lint-cm
        //eslint-disable-next-line
    }, [billingGroups])
    useEffect(() => {
        getDocuments()
    }, [])
    const handleShowEditBillingGroup = () => {
        setShowEmailPreview(false);
        setShowEditBillingGroup(true);
    }

    const handleShowUploader = () => {
        setShowUploader(!showUploader)
        let elem = document.getElementById("Invoice-Email-Preview-Modal")
        //logic is backwards because its waiting for a state update (ben kile)
        if (showUploader && elem) {
            // elem.style.opacity = "1"
            elem.style.display = "block"
        } else if (elem) {
            // elem.style.opacity = ".6"
            elem.style.display = "none"
        }
    }

    const handlesetAttachmentName = (name: string) => {
        setAttachmentName(name)
    }


    const sendFileLocationToApi = (relativePath: string) => {
        setRelativePathString(relativePath);
        //console.log("sendFileLocationToApi", relativePath)
    }

    let newConfig = {
        ...config,
        //r-18-lint-cm
        //eslint-disable-next-line
        ["headers"]: {
            ...config.headers,
            //r-18-lint-cm
            //eslint-disable-next-line
            ["Content-Type"]: "application/json",
            //r-18-lint-cm
            //eslint-disable-next-line
            ["Accept"]: "application/json"
        }
    };

    const getDocuments = () => {
        Axios.post(`${process.env.REACT_APP_API_URL}/api/ip/GetInvoiceProgressAttachment`, {
            InvoiceNumber: currentInvoice.InvoiceNumber, 
            EmployeeID: employeeID, 
            isPDF: currentBillingGroup.isPDF, 
            isXlsx: currentBillingGroup.isXLSX,
            InvoiceStoreLocation: currentBillingGroup.InvoiceStorageLocation
        }, AxiosConfig.configValue("min"))
            .then(res => {
                if(!res.data.error.success){
                    snackBar({ type: "error", text: `Error getting attachments(Please check invoice file(s) are in sharepoint): ${res.data.error.message}`, timeout: 3000 })
                    setShowEmailPreview(false)
                    return
                }
                var data = res.data.data as fileObject[]
                setFiles([...data])
            }).catch(err => {
            }).finally(() => {
                setLoadingFile(false)
            })
    }

    const sendEmailInfoToApi = () => {


        Axios.post(`${process.env.REACT_APP_API_URL}/api/file/emailinvoicespost`, emailProperties, newConfig)
            .then((res) => {
                if(res.status===200){
                    var datesent = new Date(Date.now())
                    datesent.setHours(0,0,0,0)
                    if(currentInvoice.DateSent===null){
                        props.saveInvoice({...currentInvoice, DateSent: datesent}, props.invoiceIndex)
                    }
                }
                else{
                    alert("Error sending email")
                }
                //console.log(`Email Sent.`, res.data)
            })
            .catch((err) => {
                //console.log(`%c Error with sending invoice with attachment to api ${err}`, "color: red; font-weight: bold; font-size: 18px")
            })

        // console.group(`%c Items for sending invoice `, "color: chartreuse; font-weight: bold; font-size: 16px")
        //     //console.log(stringyAttachmentObject);
        // console.groupEnd()
        setShowEmailPreview(false);
    }

    return (
        <>
            {
                loaded &&
                <>
                    <div className='email-preview-div'>
                        <div className='title-container d-flex flex-row'>
                            <div className='title-div col-11'>
                                <h2 className='title-text'>Invoice Email Preview</h2>
                            </div>
                            <div className='col-1 title-right-div'>
                                <i className="white-text material-icons action-text-light p-1" onClick={() => setShowEmailPreview(false)} style={{cursor: "pointer"}}>close</i>
                            </div>
                        </div>
                        <div className='outer-email-container '>
                            <div className='email-options d-flex flex-row'>
                                <div className='col-1' >
                                    {shouldAllowAccess("IP:ADMIN") ?
                                        <Button className='button-billing-group' variant='outline-secondary' onClick={handleShowEditBillingGroup} disabled={showSpecialInstructions}>
                                            Edit <br /> Billing Group
                                        </Button>
                                        :
                                        <Button disabled={true} className='button-billing-group' variant='outline-secondary' >
                                            Edit <br /> Billing Group
                                        </Button>
                                    }
                                </div>
                                <div className='col-1'></div>
                                <div className='col-1' >
                                    {/* split for options at top of email preview */}
                                </div>
                                <div className='col-7 options-div'></div>
                                <div className='col-2 ' >
                                    <Button className='button-close' variant='outline-danger' onClick={() => setShowEmailPreview(false)} disabled={showSpecialInstructions}>
                                        Close Preview
                                    </Button>
                                </div>
                            </div>
                            <div className="options-container d-flex flex-row">
                                <div className='send-div col-1'>
                                    <Button
                                        className='button-send btn'
                                        variant='outline-primary'
                                        onClick={sendEmailInfoToApi}
                                        disabled={!Object.values(emailValidation).every(x => x === true) || showSpecialInstructions || loadingFile}
                                    >
                                        Send
                                    </Button>
                                </div>
                                <div className='to-from-container col-11'>
                                    <div className='email-to-div d-flex flex-row col-11'>
                                        <Button className='button-to option-button' variant='outline-primary' disabled={showSpecialInstructions}>To</Button>
                                        <Form.Control 
                                            type="text" 
                                            className='input-to option-input' 
                                            value={emailProperties.to} 
                                            onChange={(e) => updateEmailProperties("to", e.target.value)}
                                        />
                                        {
                                            emailValidation.to?
                                            null:
                                            <DisplayEmailError message="Invalid Email(s)"/>
                                        }
                                    </div>
                                    <div className='cc-div d-flex flex-row col-11'>
                                        <Button className='button-cc option-button' variant='outline-primary' disabled={showSpecialInstructions}>CC</Button>
                                        <Form.Control 
                                            type="text" 
                                            className='input-cc option-input' 
                                            value={emailProperties.cc} 
                                            onChange={(e) => updateEmailProperties("cc", e.target.value)}
                                        />
                                        {
                                            emailValidation.cc?
                                            null:
                                            <DisplayEmailError message="Invalid Email(s)"/>
                                        }
                                    </div>
                                    <div className='bcc-div d-flex flex-row col-11'>
                                        <Button className='button-bcc option-button' variant='outline-primary' disabled={showSpecialInstructions}>BCC</Button>
                                        <Form.Control 
                                            type="text" 
                                            className='input-bcc option-input' 
                                            value={emailProperties.bcc} 
                                            onChange={(e) => updateEmailProperties("bcc", e.target.value)}
                                        />
                                        {
                                            emailValidation.bcc?
                                            null:
                                            <DisplayEmailError message="Invalid Email(s)"/>
                                        }
                                    </div>
                                    <div className='subject-div d-flex flex-row col-11'>
                                        <Button className='button-bcc option-button' variant='outline-secondary' disabled={showSpecialInstructions}>Subject</Button>
                                        <Form.Control 
                                            type="text" 
                                            className='input-subject option-input' 
                                            value={makeSubjectForInvoiceEmail(emailProperties.subject)} 
                                            onChange={(e) => updateEmailProperties("subject", e.target.value)}
                                        />
                                        {
                                            emailValidation.subject?
                                            null:
                                            <DisplayEmailError message="Subject must have a value"/>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='body-and-attachment-div col-12'>
                                <div className='InvoiceFileAttachmentControls'>
                                    {/* //!! Need to fix this to get the attachment or item!!! */}
                                    {attachmentName && <div className='InvoiceFileAttachmentContainsFileControlsLeft'>
                                        <div className='InvoiceFileAttachmentContainsFileLabel'>
                                            <span>Attachment:</span>
                                        </div>
                                        {files.map((thisFile:fileObject, idx: number) => {
                                            return(
                                                <div className="InvoiceDocViewerModalIndividual">
                                                    <div className="InvoiceDocViewerModalHeader">
                                                        <IconBuilder
                                                            extension={thisFile.extension}
                                                            size={40}
                                                        />
                                                    </div>
                                                    <div className="InvoiceDocViewerModalBody">
                                                        <a href={thisFile.url} key={idx} target='_blank'>{currentInvoice.InvoiceNumber}{thisFile.extension}</a>
                                                    </div>
                                                </div>
                                            )
                                            
                                        })}

                                    </div>}
                                    {!attachmentName && <div className='InvoiceFileAttachmentContainsNoFileControlsLeft'>
                                        <p >Attach a file</p>
                                    </div>}
                                </div>
                                <div className='body-sig-div col-12'>
                                    <div dangerouslySetInnerHTML={createMessage(currentBillingGroup)} className='body-div col-12'></div>
                                    <div dangerouslySetInnerHTML={createSignature(currentBillingGroup)} className='sig-div col-12'></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            {
                <Modal show={showSpecialInstructions} id="special-instructions-modal" size='sm'>
                    <Modal.Header>
                        <h3>Special Instructions</h3>
                    </Modal.Header>
                    <Modal.Body>
                        <span className='special-instructions-text'>
                            {(currentBillingGroup.SpecialInstructions !== null) && currentBillingGroup.SpecialInstructions}
                        </span>

                    </Modal.Body>
                    <Modal.Footer>

                        <div className='special-instructions-footer'>
                            <Button className='special-instructions-close-button' onClick={() => setShowSpecialInstructions(false)}>Close</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            }
            {/* {showUploader &&
                <InvoiceUploader
                    toggleInvoiceUploader={handleShowUploader}
                    //@ts-ignore
                    sendFileLocationToApi={sendFileLocationToApi}
                    setAttachmentName={handlesetAttachmentName}
                    //@ts-ignore
                    directory={currentBillingGroup.InvoiceStorageLocation}
                    invoice={currentInvoice}
                    invoiceProgressID={currentInvoice.InvoiceProgressID}
                    //@ts-ignore
                    storageLocation={storageLocation}//different in prod
                    //@ts-ignore
                    containerName={containerName}//different in prod
                    //@ts-ignore
                    fileStoreLocationId={fileStoreLocationId}//different in prod
                    setAttachmentID={setAttachmentID}
                />
            } */}
        </>
    )
}

export default InvoiceEmailPreview;